var carModel = [
  {
    car: 'Tesla',
    value: [
      {
        model: 'Model 3',
        value: [
          {
            year: '2021-2023',
            url: 'https://eu.3wliners.com/products/car-floor-mats-for-tesla-model-3-with-carpet',
          },
        ],
      },
      {
        model: 'Model 3 Highland',
        value: [
          {
            year: '2024-2026',
            url: 'https://eu.3wliners.com/collections/tesla-new-model-3',
          },
        ],
      },
      {
        model: 'Model 3 Standard',
        value: [
          {
            year: '2026',
            url: 'https://eu.3wliners.com/products/tesla-model-3-standard',
          },
        ],
      },
      {
        model: 'Model Y',
        value: [
          {
            year: '2020-2024',
            url: 'https://eu.3wliners.com/collections/tesla-model-y',
          },
          {
            year: '2025-2027',
            url: 'https://eu.3wliners.com/products/car-floor-mats-for-tesla-model-y-juniper',
          },
        ],
      },
      {
        model: 'Model Y Standard',
        value: [
          {
            year: '2026-2027',
            url: 'https://eu.3wliners.com/products/car-mats-for-tesla-model-y-standard',
          },
        ],
      },
      {
        model: 'Model Y L',
        value: [
          {
            year: '2026-2027',
            url: 'https://eu.3wliners.com/products/car-mats-for-tesla-model-y-l',
          },
        ],
      },
      {
        model: 'Cybertruck',
        value: [
          {
            year: '2024-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-tesla-cybertruck',
          },
        ],
      },
      {
        model: 'Model X',
        value: [
          {
            year: '2021-2026',
            url: 'https://eu.3wliners.com/collections/tesla-model-x',
          },
        ],
      },
      {
        model: 'Model S',
        value: [
          {
            year: '2022-2026',
            url: 'https://eu.3wliners.com/collections/tesla-model-s',
          },
        ],
      },
    ],
  },
  {
    car: 'BMW',
    value: [
      {
        model: 'iX',
        value: [
          {
            year: '2022-2025',
            url: 'https://eu.3wliners.com/products/car-mats-for-bmw-ix-i20',
          },
        ],
      },
      {
        model: 'iX1',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-bmw-ix1-u11',
          },
        ],
      },
      {
        model: 'iX3',
        value: [
          {
            year: '2021-2025',
            url: 'https://eu.3wliners.com/products/boot-liner-for-bmw-ix3-g01',
          },
        ],
      },
      {
        model: 'X1 F48',
        value: [
          {
            year: '2016-2021',
            url: 'https://eu.3wliners.com/products/car-mats-for-bmw-x1-f48',
          },
        ],
      },
      {
        model: 'X1 U11',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/boot-liner-for-bmw-x1-u11',
          },
        ],
      },
      {
        model: 'X2 F39',
        value: [
          {
            year: '2018-2023',
            url: 'https://eu.3wliners.com/products/car-mats-for-bmw-x2-f39',
          },
        ],
      },
      {
        model: 'X3 G01',
        value: [
          {
            year: '2021-2024',
            url: 'https://eu.3wliners.com/collections/bmw-x3',
          },
        ],
      },
      {
        model: 'X3 G45',
        value: [
          {
            year: '2025-2026',
            url: 'https://eu.3wliners.com/products/boot-liners-for-bmw-x3-g45',
          },
        ],
      },
      {
        model: 'X3 F25',
        value: [
          {
            year: '2011-2017',
            url: 'https://eu.3wliners.com/products/car-msts-for-bmw-x3-f25',
          },
        ],
      },
      {
        model: 'X4 G02',
        value: [
          {
            year: '2019-2024',
            url: 'https://eu.3wliners.com/products/boot-liner-for-bmw-x4-g02',
          },
        ],
      },
      {
        model: 'X5 G05',
        value: [
          {
            year: '2019-2026',
            url: 'https://eu.3wliners.com/collections/bmw-x5',
          },
        ],
      },
      {
        model: 'X6',
        value: [
          {
            year: '2020-2027',
            url: 'https://eu.3wliners.com/products/car-mats-for-bmw-x6-g06',
          },
        ],
      },
      {
        model: 'X7',
        value: [
          {
            year: '2020-2027',
            url: 'https://eu.3wliners.com/collections/bmw-x7',
          },
        ],
      },
      {
        model: 'M3',
        value: [
          {
            year: '2013-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-bmw-m3-4-doors-f80',
          },
        ],
      },
      {
        model: '1 Series',
        value: [
          {
            year: '2020-2024',
            url: 'https://eu.3wliners.com/products/car-mats-for-bmw-1-series-2xiang-f40',
          },
        ],
      },
      {
        model: '2 Series',
        value: [
          {
            year: '2015-2024',
            url: 'https://eu.3wliners.com/products/car-mats-for-bmw-2-series-f45',
          },
        ],
      },
      {
        model: '3 Series F30',
        value: [
          {
            year: '2012-2018',
            url: 'https://eu.3wliners.com/products/car-mats-for-bmw-3-series-f30',
          },
        ],
      },
      {
        model: '3 Series S G20',
        value: [
          {
            year: '2019-2025',
            url: 'https://eu.3wliners.com/products/car-mats-for-bmw-3-series-s-g20',
          },
        ],
      },
      {
        model: '5 Series S G30',
        value: [
          {
            year: '2017-2023',
            url: 'https://eu.3wliners.com/products/car-mats-for-bmw-5-series-s-g30',
          },
        ],
      },
      {
        model: '5 Series G60',
        value: [
          {
            year: '2024-2026',
            url: 'https://eu.3wliners.com/products/car-floor-mats-for-bmw-5-series-g60',
          },
        ],
      },
      {
        model: '7 Series',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-bmw-7-series-g70',
          },
        ],
      },
    ],
  },
  {
    car: 'CUPRA',
    value: [
      {
        model: 'Terramar',
        value: [
          {
            year: '2025-2026',
            url: 'https://eu.3wliners.com/en-de/products/3w-all-weather-car-floor-mats-for-cupra-terramar',
          },
        ],
      },
    ],
  },
  {
    car: 'Toyota',
    value: [
      {
        model: 'RAV4',
        value: [
          {
            year: '2019-2025',
            url: 'https://eu.3wliners.com/products/car-mats-for-toyota-rav4-xa50',
          },
        ],
      },
      {
        model: 'Corolla',
        value: [
          {
            year: '2020-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-toyota-corolla',
          },
        ],
      },
    ],
  },
  {
    car: 'Mercedes Benz',
    value: [
      {
        model: 'A Class',
        value: [
          {
            year: '2019-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-mercedes-benz-a-class-w177',
          },
        ],
      },
      {
        model: 'B Class W247',
        value: [
          {
            year: '2019-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-mercedes-benz-b-class-w247',
          },
        ],
      },
      {
        model: 'B Class W246',
        value: [
          {
            year: '2011-2018',
            url: 'https://eu.3wliners.com/products/car-mats-for-mercedes-benz-b-class-w246',
          },
        ],
      },
      {
        model: 'C Class W205',
        value: [
          {
            year: '2014-2021',
            url: 'https://eu.3wliners.com/products/car-mats-for-benz-c-class-s-sedan-station-wagon-w205',
          },
        ],
      },
      {
        model: 'C Class W206',
        value: [
          {
            year: '2022-2026',
            url: 'https://eu.3wliners.com/products/boot-liner-for-mercedes-benz-c-class',
          },
        ],
      },
      {
        model: 'E Class W214',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-benz-e-class-s-w214',
          },
        ],
      },
      {
        model: 'E Class W213',
        value: [
          {
            year: '2016-2022',
            url: 'https://eu.3wliners.com/products/boot-liner-for-mercedes-benz-e-class-w213',
          },
        ],
      },
      {
        model: 'G Class W463',
        value: [
          {
            year: '2020-2026',
            url: 'https://eu.3wliners.com/products/boot-mats-for-mercedes-benz-g-class-w463',
          },
        ],
      },
      {
        model: 'V Class W447',
        value: [
          {
            year: '2015-2024',
            url: 'https://eu.3wliners.com/products/car-mats-for-benz-v-class-w447',
          },
        ],
      },
      {
        model: 'S Class W223',
        value: [
          {
            year: '2021-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-mercedes-benz-s-class-w223',
          },
        ],
      },
      {
        model: 'S Class Long W223',
        value: [
          {
            year: '2021-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-benz-s-class-long-w223',
          },
        ],
      },
      {
        model: 'CLA C117',
        value: [
          {
            year: '2013-2018',
            url: 'https://eu.3wliners.com/products/car-mats-for-benz-cla-c117-3-xiang-a-class-w176-2-xiang',
          },
        ],
      },
      {
        model: 'CLA C118',
        value: [
          {
            year: '2019-2024',
            url: 'https://eu.3wliners.com/products/car-mats-for-mercedes-benz-cla-c118-3xiang-gla-h247',
          },
        ],
      },
      {
        model: 'GLA X156',
        value: [
          {
            year: '2014-2020',
            url: 'https://eu.3wliners.com/products/car-mats-for-mercedes-benz-gla-x156',
          },
        ],
      },
      {
        model: 'GLB X247',
        value: [
          {
            year: '2020-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-mercedes-benz-glb-x247',
          },
        ],
      },
      {
        model: 'GLC X254',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-mercedes-benz-glc-s-x254',
          },
        ],
      },
      {
        model: 'GLC X253',
        value: [
          {
            year: '2016-2022',
            url: 'https://eu.3wliners.com/products/boot-liner-for-mercedes-benz-glc-x253',
          },
        ],
      },
      {
        model: 'GLE W166',
        value: [
          {
            year: '2016-2019',
            url: 'https://eu.3wliners.com/products/car-mats-for-benz-gle-w166',
          },
        ],
      },
      {
        model: 'GLE V167',
        value: [
          {
            year: '2020-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-mercedes-benz-gle-v167',
          },
        ],
      },
      {
        model: 'GLS X167',
        value: [
          {
            year: '2020-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-mercedes-benz-gls-x167',
          },
        ],
      },
    ],
  },
  {
    car: 'Hyundai',
    value: [
      {
        model: 'Ioniq 5',
        value: [
          {
            year: '2021-2024',
            url: 'https://eu.3wliners.com/products/car-mats-for-hyundai-ioniq-5-ne',
          },
        ],
      },
      {
        model: 'Tucson NX4',
        value: [
          {
            year: '2021-2024',
            url: 'https://eu.3wliners.com/products/car-mats-for-hyundai-tucson-nx4',
          },
        ],
      },
    ],
  },
  {
    car: 'Kia',
    value: [
      {
        model: 'EV6',
        value: [
          {
            year: '2021-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-kia-ev6-cv',
          },
        ],
      },
      {
        model: 'EV3',
        value: [
          {
            year: '2024-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-kia-ev3',
          },
        ],
      },
      {
        model: 'Sportage',
        value: [
          {
            year: '2023-2027',
            url: 'https://eu.3wliners.com/en-de/products/boot-mats-for-kia-sportage',
          },
        ],
      },
    ],
  },
  {
    car: 'Volkswagen',
    value: [
      {
        model: 'ID.4',
        value: [
          {
            year: '2021-2026',
            url: 'https://eu.3wliners.com/products/boot-liner-for-volkswagen-id-4',
          },
        ],
      },
      {
        model: 'ID.3',
        value: [
          {
            year: '2020-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-volkswagen-id-3',
          },
        ],
      },
      {
        model: 'ID.7',
        value: [
          {
            year: '2024-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-volkswagen-id-7',
          },
        ],
      },
      {
        model: 'Touareg 3',
        value: [
          {
            year: '2019-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-volkswagen-touareg',
          },
        ],
      },
      {
        model: 'Tiguan',
        value: [
          {
            year: '2018-2024',
            url: 'https://eu.3wliners.com/products/car-mats-for-volkswagen-tiguan',
          },
          {
            year: '2025-2026',
            url: 'https://eu.3wliners.com/products/car-floor-mats-for-volkswagen-tiguan',
          },
        ],
      },
      {
        model: 'T-Roc',
        value: [
          {
            year: '2026',
            url: 'https://eu.3wliners.com/en-de/products/3w-all-weather-car-floor-mats-for-volkswagen-t-roc-left-hand-drive',
          },
        ],
      },
    ],
  },
  {
    car: 'Mini',
    value: [
      {
        model: 'Countryman F60',
        value: [
          {
            year: '2017-2024',
            url: 'https://eu.3wliners.com/products/boot-liner-for-mini-countryman-f60-1',
          },
        ],
      },
      {
        model: 'Countryman U25',
        value: [
          {
            year: '2024-2027',
            url: 'https://eu.3wliners.com/products/car-mats-for-mini-countryman-u25',
          },
        ],
      },
      {
        model: 'Hatch F56',
        value: [
          {
            year: '2015-2026',
            url: 'https://eu.3wliners.com/products/boot-liner-for-mini-hatch-3-doors-f56',
          },
        ],
      },
      {
        model: 'Hatch F55',
        value: [
          {
            year: '2014-2023',
            url: 'https://eu.3wliners.com/products/car-mats-for-mini-hatch-5-door-f55',
          },
        ],
      },
      {
        model: 'Cooper SE Electric',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-mini-cooper-se-3-doors-mini-electric',
          },
        ],
      },
    ],
  },
  {
    car: 'Audi',
    value: [
      {
        model: 'Q3 S F3',
        value: [
          {
            year: '2019-2025',
            url: 'https://eu.3wliners.com/products/car-mats-for-audi-q3-s-f3',
          },
        ],
      },
      {
        model: 'Q3 S 8U',
        value: [
          {
            year: '2011-2018',
            url: 'https://eu.3wliners.com/products/car-mats-for-audi-q3-s-8u',
          },
        ],
      },
      {
        model: 'Q3',
        value: [
          {
            year: '2019-2024',
            url: 'https://eu.3wliners.com/products/boot-liner-for-audi-q3',
          },
        ],
      },
      {
        model: 'Q4',
        value: [
          {
            year: '2022-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-audi-q4-s-e-tron-sportback-f4',
          },
        ],
      },
      {
        model: 'Q5',
        value: [
          {
            year: '2018-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-audi-q5-s-80a',
          },
        ],
      },
      {
        model: 'Q7',
        value: [
          {
            year: '2019-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-audi-q7-s-4m-q8-s',
          },
        ],
      },
      {
        model: 'A3 Sportback 8Y',
        value: [
          {
            year: '2021-2024',
            url: 'https://eu.3wliners.com/products/car-floor-mats-for-audi-a3-sportback-8y',
          },
        ],
      },
      {
        model: 'A3 Sportback 8V',
        value: [
          {
            year: '2013-2020',
            url: 'https://eu.3wliners.com/products/car-mats-for-audi-a3-sportback-8v',
          },
        ],
      },
      {
        model: 'A4',
        value: [
          {
            year: '2016-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-audi-a4-s-sedan-b9-8w',
          },
        ],
      },
      {
        model: 'A5',
        value: [
          {
            year: '2025-2026',
            url: 'https://eu.3wliners.com/en-de/products/3w-all-weather-car-mats-for-audi-a5-left-hand-drive',
          },
        ],
      },
      {
        model: 'A6',
        value: [
          {
            year: '2019-2025',
            url: 'https://eu.3wliners.com/products/car-mats-for-audi-a6-s-sedan-avant-c8-4k',
          },
          {
            year: '2013-2018',
            url: 'https://eu.3wliners.com/products/car-mats-for-audi-a6-sedan-c7-4g',
          },
        ],
      },
    ],
  },
  {
    car: 'Volvo',
    value: [
      {
        model: 'XC60',
        value: [
          {
            year: '2018-2027',
            url: 'https://eu.3wliners.com/products/boot-liner-for-volvo-xc60',
          },
        ],
      },
      {
        model: 'S90',
        value: [
          {
            year: '2017-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-volvo-s90',
          },
        ],
      },
    ],
  },
  {
    car: 'Leapmotor',
    value: [
      {
        model: 'C10',
        value: [
          {
            year: '2024-2025',
            url: 'https://eu.3wliners.com/products/car-mats-for-leapmotor-c10',
          },
        ],
      },
      {
        model: 'B10',
        value: [
          {
            year: '2025-2026',
            url: 'https://eu.3wliners.com/products/3w-all-weather-car-mats-for-leapmotor-b10-2025-2026',
          },
        ],
      },
    ],
  },
  {
    car: 'Xpeng',
    value: [
      {
        model: 'G6',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-xpeng-g6',
          },
        ],
      },
      {
        model: 'G9',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-xpeng-g9',
          },
        ],
      },
      {
        model: 'P7',
        value: [
          {
            year: '2025-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-xpeng-p7',
          },
        ],
      },
    ],
  },
  {
    car: 'BYD',
    value: [
      {
        model: 'Seal U',
        value: [
          {
            year: '2022-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-byd-seal-u',
          },
        ],
      },
      {
        model: 'Seal',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-byd-seal',
          },
        ],
      },
      {
        model: 'Dolphin',
        value: [
          {
            year: '2022-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-byd-dolphin',
          },
        ],
      },
      {
        model: 'Dolphin Surf',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-byd-dolphin-surf',
          },
        ],
      },
      {
        model: 'Sealion 7',
        value: [
          {
            year: '2025-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-byd-sealion-7',
          },
        ],
      },
      {
        model: 'ATTO 3 Yuan Plus',
        value: [
          {
            year: '2022-2025',
            url: 'https://eu.3wliners.com/products/car-mats-for-byd-atto-3-yuan-plus-lhd',
          },
        ],
      },
    ],
  },
  {
    car: 'Zeekr',
    value: [
      {
        model: '7X',
        value: [
          {
            year: '2024-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-zeekr-7x',
          },
        ],
      },
      {
        model: 'X',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-zeekr-x',
          },
        ],
      },
      {
        model: '001',
        value: [
          {
            year: '2022-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-zeekr-001',
          },
        ],
      },
      {
        model: '7 GT',
        value: [
          {
            year: '2025-2026',
            url: 'https://eu.3wliners.com/products/3w-all-weather-car-mats-for-zeekr-007-2025-2026-left-hand-drive',
          },
        ],
      },
    ],
  },
  {
    car: 'Ford',
    value: [
      {
        model: 'Mustang',
        value: [
          {
            year: '2021-2026',
            url: 'https://eu.3wliners.com/products/boot-liner-for-ford-mustang-mach-e',
          },
        ],
      },
      {
        model: 'Bronco 4-Door',
        value: [
          {
            year: '2021-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-ford-bronco-4-door',
          },
        ],
      },
    ],
  },
  {
    car: 'Jeep',
    value: [
      {
        model: 'Wrangler 4xe',
        value: [
          {
            year: '2021-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-jeep-wrangler-4xe',
          },
        ],
      },
    ],
  },
  {
    car: 'Jaecoo',
    value: [
      {
        model: '7',
        value: [
          {
            year: '2025-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-jaecoo-7',
          },
        ],
      },
    ],
  },
  {
    car: 'Lynk & Co',
    value: [
      {
        model: '08',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-lynk-co-08',
          },
        ],
      },
      {
        model: '01',
        value: [
          {
            year: '2020-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-lynk-co-01',
          },
        ],
      },
    ],
  },
  {
    car: 'GWM',
    value: [
      {
        model: 'WEY 05',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-gmw-wey-05',
          },
        ],
      },
      {
        model: 'ORA 03',
        value: [
          {
            year: '2020-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-gmw-ora-03',
          },
        ],
      },
    ],
  },
  {
    car: 'Nio',
    value: [
      {
        model: 'ET7',
        value: [
          {
            year: '2024-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-nio-et7',
          },
        ],
      },
      {
        model: 'EL8',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-nio-el8',
          },
        ],
      },
      {
        model: 'EL7',
        value: [
          {
            year: '2022-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-nio-el7',
          },
        ],
      },
      {
        model: 'EL6',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-nio-el6',
          },
        ],
      },
      {
        model: 'ET5',
        value: [
          {
            year: '2022-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-nio-et5',
          },
        ],
      },
      {
        model: 'ET5 Touring',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-nio-et5-touring',
          },
        ],
      },
      {
        model: 'Firefly',
        value: [
          {
            year: '2025-2026',
            url: 'https://eu.3wliners.com/products/3w-all-weather-car-mats-for-nio-firefly-2025-2026',
          },
        ],
      },
    ],
  },
  {
    car: 'Dodge Ram',
    value: [
      {
        model: 'Ram 1500',
        value: [
          {
            year: '2019-2024',
            url: 'https://eu.3wliners.com/products/car-mats-for-dodge-ram-1500',
          },
        ],
      },
    ],
  },
  {
    car: 'MG',
    value: [
      {
        model: 'IM5',
        value: [
          {
            year: '2024-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-mg-im5',
          },
        ],
      },
      {
        model: 'IM6',
        value: [
          {
            year: '2025-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-mg-im6',
          },
        ],
      },
    ],
  },
  {
    car: 'Skoda',
    value: [
      {
        model: 'Elroq',
        value: [
          {
            year: '2025-2027',
            url: 'https://eu.3wliners.com/products/car-mats-for-skoda-elroq',
          },
        ],
      },
      {
        model: 'Kodiaq',
        value: [
          {
            year: '2025-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-skoda-kodiaq',
          },
        ],
      },
      {
        model: 'Superb',
        value: [
          {
            year: '2016-2025',
            url: 'https://eu.3wliners.com/products/car-mats-for-skoda-superb',
          },
        ],
      },
    ],
  },
  {
    car: 'Peugeot',
    value: [
      {
        model: '3008',
        value: [
          {
            year: '2024-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-peugeot-3008',
          },
        ],
      },
    ],
  },
  {
    car: 'Lexus',
    value: [
      {
        model: 'NX',
        value: [
          {
            year: '2022-2026',
            url: 'https://eu.3wliners.com/products/boot-liner-for-lexus-nx',
          },
        ],
      },
    ],
  },
  {
    car: 'Nissan',
    value: [
      {
        model: 'Qashqai',
        value: [
          {
            year: '2021-2026',
            url: 'https://eu.3wliners.com/products/nissan-qashqai-j12-mid-e',
          },
        ],
      },
    ],
  },
  {
    car: 'Land Rover',
    value: [
      {
        model: 'Defender 110 5 Seat',
        value: [
          {
            year: '2020-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-land-rover-defender-110-5-seats-l663',
          },
        ],
      },
      {
        model: 'Defender 110 7 Seat',
        value: [
          {
            year: '2020-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-defender-110-7-seats',
          },
        ],
      },
      {
        model: 'Defender 90',
        value: [
          {
            year: '2020-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-land-rover-defender-90-l663',
          },
        ],
      },
      {
        model: 'Defender 130',
        value: [
          {
            year: '2020-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-land-rover-defender-130-l663',
          },
        ],
      },
      {
        model: 'Discovery Sport',
        value: [
          {
            year: '2022-2026',
            url: 'https://eu.3wliners.com/products/boot-liner-for-land-rover-discovery-sport-l550',
          },
        ],
      },
      {
        model: 'Range Rover Evoque S L551',
        value: [
          {
            year: '2022-2026',
            url: 'https://eu.3wliners.com/products/car-mats-range-rover-evoque-l551',
          },
        ],
      },
      {
        model: 'Range Rover L460',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-range-rover-l460',
          },
        ],
      },
      {
        model: 'Range Rover Velar L560',
        value: [
          {
            year: '2017-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-range-rover-velar-l560',
          },
        ],
      },
      {
        model: 'Range Rover Sport L461',
        value: [
          {
            year: '2023-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-range-rover-sport-l461',
          },
        ],
      },
      {
        model: 'Range Rover New Sport',
        value: [
          {
            year: '2023-2024',
            url: 'https://eu.3wliners.com/products/boot-liner-for-range-rover-new-sport',
          },
        ],
      },
      {
        model: 'Range Rover Sport L494',
        value: [
          {
            year: '2014-2022',
            url: 'https://eu.3wliners.com/products/3w-all-weather-boot-liner-for-range-rover-sport-l494-2014-2022',
          },
        ],
      },
    ],
  },
  {
    car: 'Porsche',
    value: [
      {
        model: 'Macan',
        value: [
          {
            year: '2014-2026',
            url: 'https://eu.3wliners.com/products/boot-liner-for-porsche-macan',
          },
        ],
      },
      {
        model: 'Cayenne',
        value: [
          {
            year: '2018-2026',
            url: 'https://eu.3wliners.com/products/boot-liner-for-porsche-cayenne',
          },
        ],
      },
      {
        model: 'Panamera',
        value: [
          {
            year: '2017-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-porsche-panamera-long-971',
          },
        ],
      },
      {
        model: '718',
        value: [
          {
            year: '2016-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-porsche-718-boxster-cayman-spyder',
          },
        ],
      },
      {
        model: '911',
        value: [
          {
            year: '2013-2026',
            url: 'https://eu.3wliners.com/products/car-mats-for-porsche-991-992',
          },
        ],
      },
    ],
  },
];
